import { Helmet } from "react-helmet-async";

const SITE_NAME = "YourPlants.in";
const SITE_URL = "https://yourplants.in";
const DEFAULT_DESCRIPTION =
  "YourPlants.in — Aapka Plant, Aapke Liye. A smart plant marketplace delivering quality plants from trusted local nurseries to your doorstep with Pay After Check, AI Plant Doctor, Plant Scan, and Design My Space services.";
const DEFAULT_IMAGE = `${SITE_URL}/full_logo_transparent.png`;

export default function Seo({
  title,
  description = DEFAULT_DESCRIPTION,
  path = "",
  image = DEFAULT_IMAGE,
  noindex = false,
}) {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} | Aapka Plant, Aapke Liye`;
  const url = `${SITE_URL}${path}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:locale" content="en_IN" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}
